<template>
  <div class="section-wrap section-column-wrap" id="app">
    <div class="section-column section-content serp-input-container">
      <div class="field">
        <label for="url">URL</label>
        <input name="url" type="url" v-model="url" placeholder="Include full url. e.g. https://www.whitechalkroad.com.au">
        <span class="meta-length-wrapper">
          <span class="limit" v-text="urlSize + 'px'" :class="{ overlimit: overLimit(urlSize, urlLimit) }"></span> / <span v-text="urlLimit + 'px'"></span>
        </span>
      </div>

      <div class="field">
        <label for="title">Title</label>
        <input name="title" type="text" v-model="title">
        <span class="meta-length-wrapper">
          <span class="limit" v-text="titleSize + 'px'" :class="{ overlimit: overLimit(titleSize, titleLimit) }"></span> / <span v-text="titleLimit + 'px'"></span>
        </span>
      </div>

      <div class="field">
        <label for="description">Description</label>
        <textarea name="description" type="text-area" rows="4" cols="50" v-model="description">
        </textarea>
        <span class="meta-length-wrapper">
            <span class="limit" v-text="descriptionSize + 'px'" :class="{ overlimit: overLimit(descriptionSize, descriptionLimit) }"></span> / <span v-text="descriptionLimit + 'px'"></span>
        </span>
      </div>
    </div>
    <SerpPreview
      :url="url"
      :title="title"
      :description="description"
      :urlLimit="urlLimit"
      :titleLimit="titleLimit"
      :descriptionLimit="descriptionLimit"
      @urlsizechange="urlSizeChange"
      @titlesizechange="titleSizeChange"
      @descriptionsizechange="descriptionSizeChange"
    />
  </div>
</template>

<script>
import SerpPreview from './components/SerpPreview.vue';

export default {
  name: 'App',
  components: {
    SerpPreview,
  },
  data() {
    return {
      url: '',
      title: '',
      description: '',
      urlLimit: 360,
      titleLimit: 575,
      descriptionLimit: 990,
      urlSize: 0,
      titleSize: 0,
      descriptionSize: 0,
    };
  },
  methods: {
    urlSizeChange(pixels) {
      this.urlSize = Math.floor(pixels);
    },
    titleSizeChange(pixels) {
      this.titleSize = Math.floor(pixels);
    },
    descriptionSizeChange(pixels) {
      this.descriptionSize = Math.floor(pixels);
    },
    overLimit(size, limit) {
      return size > limit;
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Arial, sans-serif;
  text-align: left;
  color: #2c3e50;
  max-width: 800px;

  @media only screen and (min-width: 1024px) {
      margin: 0 auto;
  }

  .serp-input-container {
    padding-bottom: 0;
    margin: 0;
  }

  .limit {
    color: white;
    transition: color 0.15s;
  }

  .overlimit {
    color: red;
  }

  .field {
    display: block;
    position: relative;
    color: white;

    label,
    input,
    textarea {
      display: block;
      width: 100%;
    }

    label {
      font-weight: bold;
      margin-bottom: 5px;
    }

    .meta-length-wrapper {
      position: absolute;
      right: 10px;
      top: -5px;
    }

    input {
      padding: 8px 16px;
      width: 100%;
    }
  }
}
</style>
